<template>
	<div class="np-badge np-borderless" :class="[colorStyle, size]" role="button">
		{{ progress ? progress : 0 }}%
	</div>
</template>

<script>
	export default {
		props: {
			progress: {
				type: Number,
				default: 0
			},
			size: {
				type: String,
				default: ''
			}
		},
		computed: {
			colorStyle() {
				if (this.progress < 30) {
					return 'np-danger'
				} else if (this.progress < 75) {
					return 'np-warning'
				} else {
					return 'np-success'
				}
			} 
		},
	}
</script>

<style scoped>

</style>